import { createGlobalStyle } from 'styled-components';

const RtlStyles = createGlobalStyle`
  /* Apply these styles when direction is RTL (Arabic) */
  html[dir="rtl"] {
    /* Text alignment */
    .text-left {
      text-align: right;
    }
    
    .text-right {
      text-align: left;
    }
    
    /* Padding and margin flips */
    .ml-auto {
      margin-left: 0 !important;
      margin-right: auto !important;
    }
    
    .mr-auto {
      margin-right: 0 !important;
      margin-left: auto !important;
    }
    
    /* Header styles */
    .header-nav {
      flex-direction: row-reverse;
    }
    
    /* Footer specific styles */
    .footer-columns {
      flex-direction: row-reverse;
    }
    
    /* Form elements */
    input, textarea {
      text-align: right;
    }
    
    /* Font adjustments for Arabic */
    body {
      font-family: 'Cairo', 'Arial', sans-serif;
      letter-spacing: 0;
    }
  }
`;

export default RtlStyles;
